module.exports = __webpack_public_path__ + "media/images/features/support/eyecatch-mv-f213b45e4d7184d9341bb6fa71aef9e4.png";